import { defineMessages } from 'react-intl-next';

export default defineMessages({
    addComment: {
        defaultMessage: 'Add a comment',
        description: 'Text for add comment button',
        id: 'cv.feedback.confirm.page.submit.button.text',
    },
    commentPlaceholder: {
        defaultMessage: 'Optional comment',
        description: 'Placeholder for comment text area',
        id: 'cv.feedback.confirm.page.comment.placeholder',
    },
});
